import * as React from "react";

interface PropTypes {}

export const AddFollowSvg = (props: PropTypes) => (
	<svg
		width="16"
		height="16"
		viewBox="0 0 16 16"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<circle
			cx="8.48462"
			cy="8.48462"
			r="7.51538"
			fill="url(#paint0_linear_1_5916)"
		/>
		<g clip-path="url(#clip0_1_5916)">
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M10.3596 6.23462C10.3596 7.27015 9.52014 8.10962 8.48462 8.10962C7.44909 8.10962 6.60962 7.27015 6.60962 6.23462C6.60962 5.19909 7.44909 4.35962 8.48462 4.35962C9.52014 4.35962 10.3596 5.19909 10.3596 6.23462ZM7.73462 8.85962C6.28487 8.85962 5.10962 10.0349 5.10962 11.4846C5.10962 12.106 5.6133 12.6096 6.23462 12.6096H9.01311C9.17518 12.6096 9.26724 12.4117 9.18332 12.273C8.97786 11.9335 8.85962 11.5354 8.85962 11.1096C8.85962 10.3468 9.23919 9.67269 9.81977 9.26578C9.95604 9.17031 9.94442 8.95119 9.78163 8.91669C9.60519 8.87931 9.42219 8.85962 9.23462 8.85962H7.73462ZM11.1096 9.60962C11.3167 9.60962 11.4846 9.77751 11.4846 9.98462V10.7346H12.2346C12.4417 10.7346 12.6096 10.9025 12.6096 11.1096C12.6096 11.3167 12.4417 11.4846 12.2346 11.4846H11.4846V12.2346C11.4846 12.4417 11.3167 12.6096 11.1096 12.6096C10.9025 12.6096 10.7346 12.4417 10.7346 12.2346V11.4846H9.98462C9.77751 11.4846 9.60962 11.3167 9.60962 11.1096C9.60962 10.9025 9.77751 10.7346 9.98462 10.7346H10.7346V9.98462C10.7346 9.77751 10.9025 9.60962 11.1096 9.60962Z"
				fill="white"
			/>
		</g>
		<defs>
			<linearGradient
				id="paint0_linear_1_5916"
				x1="8.48462"
				y1="17.4091"
				x2="8.48462"
				y2="2.37837"
				gradientUnits="userSpaceOnUse"
			>
				<stop stop-color="#0035EE" />
				<stop offset="1" stop-color="#7695FF" />
			</linearGradient>
			<clipPath id="clip0_1_5916">
				<rect
					width="9"
					height="9"
					fill="white"
					transform="translate(3.98462 3.98462)"
				/>
			</clipPath>
		</defs>
	</svg>
);
